<template>
    <div class="small text-center">
        <span v-if="content">{{$filters.numberFormat(contentSize)}}</span>
        <span v-else>0</span>
        {{contentUnit}}
        /
        {{$filters.numberFormat(maxSize)}} {{maxUnit}}
        <div class="progress" style="height: 2px;">
            <div class="progress-bar" role="progressbar"
                :class="{'bg-danger': storage >= 95}"
                :style="{width: storage + '%'}"
                aria-valuenow="storage" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            default: ""
        },
    },
    data() {
        return {
            B: 10240,
            KB: 10485760,
        }
    },
    computed: {
        max() {
            return this.$store.state.max_note_size || 65536;
        },
        storage() {
            if (!this.content) return 0;
            const len = encodeURI(this.content).replace(/%../g, "*").length;
            let percentage = len / this.max * 100;
            if (percentage > 100) percentage = 100;
            return percentage;
        },
        maxSize() {
            if (this.max < this.B) {
                return this.max;
            } else if (this.max < this.KB) {
                return Math.round(this.max / 1024);
            }
            return Math.round(this.max / 1048576);
        },
        maxUnit() {
            if (this.max < this.B) {
                return "B";
            } else if (this.max < this.KB) {
                return "KB";
            }
            return "MB";
        },
        contentSize() {
            const len = encodeURI(this.content).replace(/%../g, "*").length;
            if (len < this.B) {
                return len;
            } else if (len < this.KB) {
                return Math.round(len / 1024);
            }
            return Math.round(len / 1048576);
        },
        contentUnit() {
            const len = encodeURI(this.content).replace(/%../g, "*").length;
            if (len < this.B) {
                return "B";
            } else if (len < this.KB) {
                return "KB";
            }
            return "MB";
        },
    },
}
</script>